export enum ExpireTypes { 
  Count = 'count', 
  Time = 'time' 
}

export enum ModeTypes { 
  OnlyView = 'only_view', 
  All = 'all' 
}

export interface SharedLinkAPI {
  full_name: string;
  token: string;
  addressee_email: string;
  expires_at: string | null;
  current_visits: number;
  group_id: string | null;
  permissions: string[];
  id: string;
  expired: boolean;
  author_id: string;
  expires_limit: number;
  ext?: string;
  password?: string;
}

export interface SharedLinksResponse {
  temp_links: SharedLinkAPI[];
  pagination: {
    pages: number;
    current: number;
    per_page: number;
    total: number;
  };
}

export type SharedLink = {
  key: string;
  userName: string;
  email: string;
  status: 'active' | 'expired';
  actions: string;
  rawLink: SharedLinkAPI | null;
}; 